import url from './urls'

const state = {
  data: null,
  isLoading: false
}

const mutations = {
  GET (state, pageName) {
    state.isLoading = true

    switch (pageName) {
      case '_calendar':
        fetch(url.banner + 2)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'home':
        fetch(url.banner + 2)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'about':
        fetch(url.banner + 3)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'creativity_program':
        fetch(url.banner + 5)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'creativity_talk_symposium':
        fetch(url.banner + 5)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'creativity_talk_symposium_detail':
        fetch(url.banner + 5)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'creativity_school_of_creativity':
        fetch(url.banner + 5)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'creativity_school_of_creativity_detail':
        fetch(url.banner + 5)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'awards':
        fetch(url.banner + 4)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'category-detail':
        fetch(url.banner + 4)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'news':
        fetch(url.banner + 6)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'news-detail':
        fetch(url.banner + 6)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'winners':
        fetch(url.banner + 7)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'archive':
        fetch(url.banner + 7)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'archive-detail':
        fetch(url.banner + 7)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'gallery':
        fetch(url.banner + 8)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break

      case 'contact':
        fetch(url.banner + 9)
          .then(response => response.json())
          .then(data => {
            state.isLoading = false
            state.data = data
          })
          .catch(err => {
            state.isLoading = false
            console.error(err)
          })

        break
    }
  }
}

const actions = {
  get ({ commit }, pageName) {
    commit('GET', pageName)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
